'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Vegetable providing diary
 */
var VegetableDiary = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(VegetableDiary, _Component);

  function VegetableDiary() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, VegetableDiary);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = VegetableDiary.__proto__ || (0, _getPrototypeOf2.default)(VegetableDiary)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      table1: {
        morning: {
          vegetables: '',
          childaccepted: ''
        },
        lunch: {
          vegetables: '',
          childaccepted: ''
        },
        afternoon: {
          vegetables: '',
          childaccepted: ''
        },
        dinner: {
          vegetables: '',
          childaccepted: ''
        },
        evening: {
          vegetables: '',
          childaccepted: ''
        },
        total: {
          vegetables: '',
          childaccepted: ''
        }
      }
    }, _this.handleVegeChange = function (snackKey, event) {
      var obj = _this.state;
      obj.table1[snackKey].vegetables = event.target.value;
      _this.setState(obj);
    }, _this.handleAcceptChange = function (snackKey, event) {
      var obj = _this.state;
      obj.table1[snackKey].childaccepted = event.target.value;
      _this.setState(obj);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(VegetableDiary, [{
    key: 'render',
    value: function render() {
      var table1 = this.state.table1;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          ReactBootstrap.Table,
          { bordered: true, striped: true },
          _react2.default.createElement(
            'thead',
            null,
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'th',
                null,
                'Time'
              ),
              _react2.default.createElement(
                'th',
                null,
                'Vegetables offered (include type and amount)'
              ),
              _react2.default.createElement(
                'th',
                null,
                'Child accepted (Tick or no tick, report if child had a taste or ate 1/2 of serve)'
              )
            )
          ),
          _react2.default.createElement(
            'tbody',
            null,
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                null,
                'Morning Snack'
              ),
              _react2.default.createElement(
                'td',
                null,
                _react2.default.createElement(ReactBootstrap.FormControl, {
                  componentClass: 'textarea',
                  value: table1.morning.vegetables,
                  placeholder: 'Vegetables offered',
                  onSelect: this.handleVegeChange.bind(this, 'morning') })
              ),
              _react2.default.createElement(
                'td',
                null,
                _react2.default.createElement(ReactBootstrap.FormControl, {
                  componentClass: 'textarea',
                  value: table1.morning.childaccepted,
                  placeholder: 'Child accepted',
                  onSelect: this.handleAcceptChange.bind(this, 'morning') })
              )
            ),
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                null,
                'Lunch'
              ),
              _react2.default.createElement(
                'td',
                null,
                _react2.default.createElement(ReactBootstrap.FormControl, {
                  componentClass: 'textarea',
                  value: table1.lunch.vegetables,
                  placeholder: 'Vegetables offered',
                  onSelect: this.handleVegeChange.bind(this, 'lunch') })
              ),
              _react2.default.createElement(
                'td',
                null,
                _react2.default.createElement(ReactBootstrap.FormControl, {
                  componentClass: 'textarea',
                  value: table1.lunch.childaccepted,
                  placeholder: 'Child accepted',
                  onSelect: this.handleAcceptChange.bind(this, 'lunch') })
              )
            ),
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                null,
                'Afternoon Snack'
              ),
              _react2.default.createElement(
                'td',
                null,
                _react2.default.createElement(ReactBootstrap.FormControl, {
                  componentClass: 'textarea',
                  value: table1.afternoon.vegetables,
                  placeholder: 'Vegetables offered',
                  onSelect: this.handleVegeChange.bind(this, 'afternoon') })
              ),
              _react2.default.createElement(
                'td',
                null,
                _react2.default.createElement(ReactBootstrap.FormControl, {
                  componentClass: 'textarea',
                  value: table1.afternoon.childaccepted,
                  placeholder: 'Child accepted',
                  onSelect: this.handleAcceptChange.bind(this, 'afternoon') })
              )
            ),
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                null,
                'Dinner'
              ),
              _react2.default.createElement(
                'td',
                null,
                _react2.default.createElement(ReactBootstrap.FormControl, {
                  componentClass: 'textarea',
                  value: table1.dinner.vegetables,
                  placeholder: 'Vegetables offered',
                  onSelect: this.handleVegeChange.bind(this, 'dinner') })
              ),
              _react2.default.createElement(
                'td',
                null,
                _react2.default.createElement(ReactBootstrap.FormControl, {
                  componentClass: 'textarea',
                  value: table1.dinner.childaccepted,
                  placeholder: 'Child accepted',
                  onSelect: this.handleAcceptChange.bind(this, 'dinner') })
              )
            ),
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                null,
                'Evening Snack'
              ),
              _react2.default.createElement(
                'td',
                null,
                _react2.default.createElement(ReactBootstrap.FormControl, {
                  componentClass: 'textarea',
                  value: table1.evening.vegetables,
                  placeholder: 'Vegetables offered',
                  onSelect: this.handleVegeChange.bind(this, 'evening') })
              ),
              _react2.default.createElement(
                'td',
                null,
                _react2.default.createElement(ReactBootstrap.FormControl, {
                  componentClass: 'textarea',
                  value: table1.evening.childaccepted,
                  placeholder: 'Child accepted',
                  onSelect: this.handleAcceptChange.bind(this, 'evening') })
              )
            ),
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                null,
                'Total'
              ),
              _react2.default.createElement(
                'td',
                null,
                _react2.default.createElement(ReactBootstrap.FormControl, {
                  componentClass: 'textarea',
                  value: table1.total.vegetables,
                  placeholder: 'Vegetables offered',
                  onSelect: this.handleVegeChange.bind(this, 'total') })
              ),
              _react2.default.createElement(
                'td',
                null,
                _react2.default.createElement(ReactBootstrap.FormControl, {
                  componentClass: 'textarea',
                  value: table1.total.childaccepted,
                  placeholder: 'Child accepted',
                  onSelect: this.handleAcceptChange.bind(this, 'total') })
              )
            )
          )
        )
      );
    }
  }]);
  return VegetableDiary;
}(_react.Component), _class.propTypes = {}, _temp2);
exports.default = VegetableDiary;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/1/Components/VegetableDiary.js
// module id = 1173
// module chunks = 0